/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { IMToken, IMTokenInterface } from "../IMToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IMToken__factory {
  static readonly abi = _abi;
  static createInterface(): IMTokenInterface {
    return new utils.Interface(_abi) as IMTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IMToken {
    return new Contract(address, _abi, signerOrProvider) as IMToken;
  }
}
